import { createGetKcContext } from "keycloakify/login";

export type KcContextExtension =
	// WARNING: It's important to keep in sync the extraThemeProperties declared in the package.json and this type definition.
	| { pageId: "login.ftl"; extraThemeProperties: { foo: string; }; }

//NOTE: In most of the cases you do not need to overload the KcContext, you can 
// just call createGetKcContext(...) without type arguments.  
// You want to overload the KcContext only if:  
// - You have custom plugins that add some values to the context (like https://github.com/micedre/keycloak-mail-whitelisting that adds authorizedMailDomains)
// - You want to add support for extra pages that are not yey featured by default, see: https://docs.keycloakify.dev/contributing#adding-support-for-a-new-page
export const { getKcContext } = createGetKcContext<KcContextExtension>({
	mockData: [
		{
			pageId: "login.ftl",
			locale: {
				//When we test the login page we do it in italian
				currentLanguageTag: "it",
			},
			//Uncomment the following line for hiding the Alert message
			//"message": undefined
			//Uncomment the following line for showing an Error message
			//message: { type: "error", summary: "This is an error" }
		},
		{
			pageId: "error.ftl",
			locale: {
				currentLanguageTag: "es",
			},
			message: {
				type: "error",
				summary: "Error al convertir algo, prueba de nuevo",
			}
		},
		// {
		// 	pageId: "my-extra-page-2.ftl",
		// 	someCustomValue: "foo bar baz"
		// },
		{
			pageId: "info.ftl",
			messageHeader: "Estas logeado",
			requiredActions: ["UPDATE_PASSWORD", "UPDATE_PROFILE"],
			skipLink: false,
			actionUri: "#",
			client: {
				clientId: "myApp",
				baseUrl: "#"
			},
			locale: {
				currentLanguageTag: "es",
			},
			message: {
				type: "info",
				summary: "Tienes una cuenta con nosotros. En breve deberías recibir un mensaje.",
			},
		},
		{
			//NOTE: You will either use register.ftl (legacy) or register-user-profile.ftl, not both
			pageId: "register-user-profile.ftl",
			locale: {
				currentLanguageTag: "fr"
			},
			profile: {
				attributes: [
					{
						validators: {
							pattern: {
								pattern: "^[a-zA-Z0-9]+$",
								"ignore.empty.value": true,
								// eslint-disable-next-line no-template-curly-in-string
								"error-message": "${alphanumericalCharsOnly}",
							},
						},
						//NOTE: To override the default mock value
						value: undefined,
						name: "username"
					},
					{
						validators: {
							options: {
								options: ["male", "female", "non-binary", "transgender", "intersex", "non_communicated"]
							}
						},
						// eslint-disable-next-line no-template-curly-in-string
						displayName: "${gender}",
						annotations: {},
						required: true,
						groupAnnotations: {},
						readOnly: false,
						name: "gender"
					}
				]
			}
		},
	]
});

export const { kcContext } = getKcContext({
	// Uncomment to test the login page for development.
	// mockPageId: "login.ftl",
	// mockPageId: "error.ftl",
	// mockPageId: "info.ftl",
	// mockPageId: "login-page-expired.ftl",
	// mockPageId: "login-reset-password.ftl",
	// mockPageId: "login-update-password.ftl"
});


export type KcContext = NonNullable<ReturnType<typeof getKcContext>["kcContext"]>;